'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../_commonjsHelpers-6ecf82ef.js');
var _extends = require('../../extends-733dd656.js');
var objectWithoutProperties = require('../../objectWithoutProperties-c6d3675c.js');
var React = require('react');
var index = require('../../index-7124f64c.js');
var taggedTemplateLiteral = require('../../taggedTemplateLiteral-f923b98d.js');
require('styled-components');
var xstyledStyledComponents_es = require('../../xstyled-styled-components.es-6e2bde7d.js');
require('../../extends-5ede7877.js');
var xstyledPropTypes_es = require('../../xstyled-prop-types.es-4220f7f4.js');
require('../../unsupportedIterableToArray-f175acfa.js');
require('../../breakpoints-ee0a4ae5.js');
require('../GlobalStyle/GlobalStyle.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../theme-80c5a73f.js');
require('../../polished.esm-8ddeb0a5.js');
require('../../colorBuilder-8c1a81a8.js');
require('../NuDSProvider/NuDSProvider.js');
var components_Image_Image = require('../Image/Image.js');
require('../../slicedToArray-a8a77f0e.js');
require('../../utils/isType/isType.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function _templateObject() {
  var data = taggedTemplateLiteral.taggedTemplateLiteral(["\n  ", ";\n  ", " \n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var getTransform = xstyledStyledComponents_es.themeGetter({
  name: 'transform',
  key: 'transforms'
});
var transform = xstyledStyledComponents_es.style({
  prop: 'transform',
  themeGet: getTransform,
  cssProperty: 'transform'
});
var transformOrigin = xstyledStyledComponents_es.style({
  prop: 'transformOrigin'
});
var marginHorizontal = xstyledStyledComponents_es.style({
  prop: 'marginHorizontal',
  cssProperty: ['marginRight', 'marginLeft'],
  themeGet: xstyledStyledComponents_es.getSpace
});
var marginVertical = xstyledStyledComponents_es.style({
  prop: 'marginVertical',
  cssProperty: ['marginTop', 'marginBottom'],
  themeGet: xstyledStyledComponents_es.getSpace
});
var paddingHorizontal = xstyledStyledComponents_es.style({
  prop: 'paddingHorizontal',
  cssProperty: ['paddingRight', 'paddingLeft'],
  themeGet: xstyledStyledComponents_es.getSpace
});
var paddingVertical = xstyledStyledComponents_es.style({
  prop: 'paddingVertical',
  cssProperty: ['paddingTop', 'paddingBottom'],
  themeGet: xstyledStyledComponents_es.getSpace
});
var styleProps = xstyledStyledComponents_es.compose(xstyledStyledComponents_es.backgroundColor, xstyledStyledComponents_es.backgroundPosition, xstyledStyledComponents_es.backgroundSize, xstyledStyledComponents_es.backgroundRepeat, xstyledStyledComponents_es.background, xstyledStyledComponents_es.borders, xstyledStyledComponents_es.flexboxes, xstyledStyledComponents_es.grids, xstyledStyledComponents_es.width, xstyledStyledComponents_es.height, xstyledStyledComponents_es.maxWidth, xstyledStyledComponents_es.maxHeight, xstyledStyledComponents_es.minWidth, xstyledStyledComponents_es.minHeight, xstyledStyledComponents_es.size, xstyledStyledComponents_es.verticalAlign, xstyledStyledComponents_es.opacity, xstyledStyledComponents_es.overflow, xstyledStyledComponents_es.transition, xstyledStyledComponents_es.positioning, xstyledStyledComponents_es.boxShadow, xstyledStyledComponents_es.margin, xstyledStyledComponents_es.marginTop, xstyledStyledComponents_es.marginRight, xstyledStyledComponents_es.marginBottom, xstyledStyledComponents_es.marginLeft, marginHorizontal, marginVertical, xstyledStyledComponents_es.padding, xstyledStyledComponents_es.paddingTop, xstyledStyledComponents_es.paddingRight, xstyledStyledComponents_es.paddingBottom, xstyledStyledComponents_es.paddingLeft, paddingHorizontal, paddingVertical, transform, transformOrigin);
var InnerBox = xstyledStyledComponents_es.createSystemComponent(React__default['default'], 'div', styleProps);
var BoxWrapper = xstyledStyledComponents_es.styled(InnerBox).withConfig({
  shouldForwardProp: function shouldForwardProp(prop, validate) {
    return validate(prop) && !styleProps.meta.props.includes(prop);
  }
})(_templateObject(), styleProps, function (_ref) {
  var backgroundImageProp = _ref.backgroundImage;
  return backgroundImageProp && components_Image_Image.backgroundImage(backgroundImageProp);
});
BoxWrapper.displayName = 'BoxWrapper';
BoxWrapper.propTypes = xstyledPropTypes_es.getSystemPropTypes(styleProps);

var Box = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
      id = props.id,
      className = props.className,
      tag = props.tag,
      border = props.border,
      borderTop = props.borderTop,
      borderTopColor = props.borderTopColor,
      borderRight = props.borderRight,
      borderRightColor = props.borderRightColor,
      borderBottom = props.borderBottom,
      borderBottomColor = props.borderBottomColor,
      borderLeft = props.borderLeft,
      borderLeftColor = props.borderLeftColor,
      borderColor = props.borderColor,
      borderWidth = props.borderWidth,
      borderStyle = props.borderStyle,
      borderRadius = props.borderRadius,
      background = props.background,
      backgroundColor = props.backgroundColor,
      backgroundImage = props.backgroundImage,
      backgroundSize = props.backgroundSize,
      backgroundPosition = props.backgroundPosition,
      backgroundRepeat = props.backgroundRepeat,
      display = props.display,
      width = props.width,
      height = props.height,
      maxWidth = props.maxWidth,
      maxHeight = props.maxHeight,
      minWidth = props.minWidth,
      minHeight = props.minHeight,
      size = props.size,
      verticalAlign = props.verticalAlign,
      alignItems = props.alignItems,
      alignContent = props.alignContent,
      justifyContent = props.justifyContent,
      justifyItems = props.justifyItems,
      flexWrap = props.flexWrap,
      flexBasis = props.flexBasis,
      flexDirection = props.flexDirection,
      flex = props.flex,
      justifySelf = props.justifySelf,
      alignSelf = props.alignSelf,
      order = props.order,
      gridGap = props.gridGap,
      gridColumnGap = props.gridColumnGap,
      gridRowGap = props.gridRowGap,
      gridColumn = props.gridColumn,
      gridRow = props.gridRow,
      gridAutoFlow = props.gridAutoFlow,
      gridAutoColumns = props.gridAutoColumns,
      gridAutoRows = props.gridAutoRows,
      gridTemplateColumns = props.gridTemplateColumns,
      gridTemplateRows = props.gridTemplateRows,
      gridTemplateAreas = props.gridTemplateAreas,
      gridArea = props.gridArea,
      boxShadow = props.boxShadow,
      margin = props.margin,
      marginTop = props.marginTop,
      marginRight = props.marginRight,
      marginBottom = props.marginBottom,
      marginLeft = props.marginLeft,
      marginHorizontal = props.marginHorizontal,
      marginVertical = props.marginVertical,
      padding = props.padding,
      paddingTop = props.paddingTop,
      paddingRight = props.paddingRight,
      paddingBottom = props.paddingBottom,
      paddingLeft = props.paddingLeft,
      paddingHorizontal = props.paddingHorizontal,
      paddingVertical = props.paddingVertical,
      position = props.position,
      zIndex = props.zIndex,
      top = props.top,
      right = props.right,
      bottom = props.bottom,
      left = props.left,
      transition = props.transition,
      opacity = props.opacity,
      overflow = props.overflow,
      onClick = props.onClick,
      transform = props.transform,
      transformOrigin = props.transformOrigin,
      rest = objectWithoutProperties.objectWithoutProperties(props, ["children", "id", "className", "tag", "border", "borderTop", "borderTopColor", "borderRight", "borderRightColor", "borderBottom", "borderBottomColor", "borderLeft", "borderLeftColor", "borderColor", "borderWidth", "borderStyle", "borderRadius", "background", "backgroundColor", "backgroundImage", "backgroundSize", "backgroundPosition", "backgroundRepeat", "display", "width", "height", "maxWidth", "maxHeight", "minWidth", "minHeight", "size", "verticalAlign", "alignItems", "alignContent", "justifyContent", "justifyItems", "flexWrap", "flexBasis", "flexDirection", "flex", "justifySelf", "alignSelf", "order", "gridGap", "gridColumnGap", "gridRowGap", "gridColumn", "gridRow", "gridAutoFlow", "gridAutoColumns", "gridAutoRows", "gridTemplateColumns", "gridTemplateRows", "gridTemplateAreas", "gridArea", "boxShadow", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginHorizontal", "marginVertical", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingHorizontal", "paddingVertical", "position", "zIndex", "top", "right", "bottom", "left", "transition", "opacity", "overflow", "onClick", "transform", "transformOrigin"]);

  var boxProps = _extends._extends_1({
    id: id,
    className: className,
    forwardedAs: tag,
    border: border,
    borderTop: borderTop,
    borderTopColor: borderTopColor,
    borderRight: borderRight,
    borderRightColor: borderRightColor,
    borderBottom: borderBottom,
    borderBottomColor: borderBottomColor,
    borderLeft: borderLeft,
    borderLeftColor: borderLeftColor,
    borderColor: borderColor,
    borderWidth: borderWidth,
    borderStyle: borderStyle,
    borderRadius: borderRadius,
    background: background,
    backgroundColor: backgroundColor,
    backgroundImage: backgroundImage,
    backgroundSize: backgroundSize,
    backgroundPosition: backgroundPosition,
    backgroundRepeat: backgroundRepeat,
    display: display,
    width: width,
    height: height,
    maxWidth: maxWidth,
    maxHeight: maxHeight,
    minWidth: minWidth,
    minHeight: minHeight,
    size: size,
    verticalAlign: verticalAlign,
    alignItems: alignItems,
    alignContent: alignContent,
    justifyContent: justifyContent,
    justifyItems: justifyItems,
    flexWrap: flexWrap,
    flexBasis: flexBasis,
    flexDirection: flexDirection,
    flex: flex,
    justifySelf: justifySelf,
    alignSelf: alignSelf,
    order: order,
    gridGap: gridGap,
    gridColumnGap: gridColumnGap,
    gridRowGap: gridRowGap,
    gridColumn: gridColumn,
    gridRow: gridRow,
    gridAutoFlow: gridAutoFlow,
    gridAutoColumns: gridAutoColumns,
    gridAutoRows: gridAutoRows,
    gridTemplateColumns: gridTemplateColumns,
    gridTemplateRows: gridTemplateRows,
    gridTemplateAreas: gridTemplateAreas,
    gridArea: gridArea,
    boxShadow: boxShadow,
    margin: margin,
    marginTop: marginTop,
    marginRight: marginRight,
    marginBottom: marginBottom,
    marginLeft: marginLeft,
    marginHorizontal: marginHorizontal,
    marginVertical: marginVertical,
    padding: padding,
    paddingTop: paddingTop,
    paddingRight: paddingRight,
    paddingBottom: paddingBottom,
    paddingLeft: paddingLeft,
    paddingHorizontal: paddingHorizontal,
    paddingVertical: paddingVertical,
    position: position,
    zIndex: zIndex,
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    transition: transition,
    opacity: opacity,
    overflow: overflow,
    onClick: onClick,
    transform: transform,
    transformOrigin: transformOrigin
  }, rest);

  return /*#__PURE__*/React__default['default'].createElement(BoxWrapper, _extends._extends_1({}, boxProps, {
    ref: ref
  }), children);
});
Box.defaultProps = {
  tag: undefined,
  id: undefined,
  className: undefined,
  children: null,
  display: undefined,
  background: undefined,
  backgroundColor: undefined,
  backgroundImage: undefined,
  backgroundSize: undefined,
  backgroundPosition: undefined,
  backgroundRepeat: undefined,
  border: undefined,
  borderTop: undefined,
  borderTopColor: undefined,
  borderRight: undefined,
  borderRightColor: undefined,
  borderBottom: undefined,
  borderBottomColor: undefined,
  borderLeft: undefined,
  borderLeftColor: undefined,
  borderColor: undefined,
  borderWidth: undefined,
  borderStyle: undefined,
  borderRadius: undefined,
  width: undefined,
  height: undefined,
  maxWidth: undefined,
  maxHeight: undefined,
  minWidth: undefined,
  minHeight: undefined,
  size: undefined,
  verticalAlign: undefined,
  boxShadow: undefined,
  alignItems: undefined,
  alignContent: undefined,
  justifyContent: undefined,
  justifyItems: undefined,
  flexWrap: undefined,
  flexBasis: undefined,
  flexDirection: undefined,
  flex: undefined,
  justifySelf: undefined,
  alignSelf: undefined,
  order: undefined,
  gridGap: undefined,
  gridColumnGap: undefined,
  gridRowGap: undefined,
  gridColumn: undefined,
  gridRow: undefined,
  gridAutoFlow: undefined,
  gridAutoColumns: undefined,
  gridAutoRows: undefined,
  gridTemplateColumns: undefined,
  gridTemplateRows: undefined,
  gridTemplateAreas: undefined,
  gridArea: undefined,
  margin: undefined,
  marginTop: undefined,
  marginRight: undefined,
  marginBottom: undefined,
  marginLeft: undefined,
  marginHorizontal: undefined,
  marginVertical: undefined,
  padding: undefined,
  paddingTop: undefined,
  paddingRight: undefined,
  paddingBottom: undefined,
  paddingLeft: undefined,
  paddingHorizontal: undefined,
  paddingVertical: undefined,
  position: undefined,
  zIndex: undefined,
  top: undefined,
  right: undefined,
  bottom: undefined,
  left: undefined,
  transition: undefined,
  transform: undefined,
  transformOrigin: undefined,
  opacity: undefined,
  overflow: undefined,
  onClick: undefined
};
Box.propTypes = {
  /** The actual HTML element to be rendered */
  tag: index.propTypes.elementType,

  /** The id that will be applied to the HTML element */
  id: index.propTypes.string,

  /** The class that will be applied to the HTML element */
  className: index.propTypes.string,

  /** The content of the component, it can be either another component or raw text */
  children: index.propTypes.oneOfType([index.propTypes.node, index.propTypes.func]),
  display: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  background: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  backgroundColor: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  backgroundImage: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  backgroundSize: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  backgroundPosition: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  backgroundRepeat: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  border: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  borderTop: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  borderTopColor: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  borderRight: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  borderRightColor: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  borderBottom: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  borderBottomColor: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  borderLeft: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  borderLeftColor: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  borderColor: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  borderWidth: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  borderStyle: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  borderRadius: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  alignItems: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  alignContent: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  justifyContent: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  justifyItems: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  flexWrap: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  flexBasis: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  flexDirection: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  flex: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  justifySelf: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  alignSelf: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  order: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  width: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  height: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  maxWidth: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  maxHeight: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  minWidth: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  minHeight: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  size: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  verticalAlign: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  boxShadow: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  gridGap: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  gridColumnGap: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  gridRowGap: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  gridColumn: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  gridRow: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  gridAutoFlow: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  gridAutoColumns: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  gridAutoRows: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  gridTemplateColumns: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  gridTemplateRows: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  gridTemplateAreas: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  gridArea: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  margin: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  marginTop: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  marginRight: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  marginBottom: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  marginLeft: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  marginHorizontal: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  marginVertical: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  padding: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  paddingTop: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  paddingRight: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  paddingBottom: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  paddingLeft: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  paddingHorizontal: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  paddingVertical: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  position: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  zIndex: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  top: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  right: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  bottom: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  left: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  transition: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  transform: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  transformOrigin: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  opacity: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  overflow: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.number, index.propTypes.object]),
  onClick: index.propTypes.func
};
Box.displayName = 'Box';

exports.default = Box;
//# sourceMappingURL=Box.js.map
